export default [
  {
    name: 'SignatureParametersList',
    path: '/settings/products/:id/signature-parameters',
    component: () => import('pages/settings/signature-parameters/SignatureParametersList.vue')
  },
  {
    name: 'SignatureParametersCreate',
    path: '/settings/products/:id/signature-parameters/new',
    component: () => import('pages/settings/signature-parameters/SignatureParametersForm.vue')
  },
  {
    name: 'SignatureParametersEdit',
    path: '/settings/products/:id/signature-parameters/:signatureParameterId/edit',
    component: () => import('pages/settings/signature-parameters/SignatureParametersForm.vue')
  }
]
